import { IconProps } from "@utils/types/components";

export const PersonIcon = ({
  width,
  height,
  color = "currentcolor",
  ...props
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.494 7.494c-.962 0-1.786-.343-2.47-1.028-.686-.685-1.028-1.508-1.028-2.47 0-.962.342-1.785 1.027-2.47C5.708.84 6.532.498 7.493.498c.963 0 1.786.343 2.471 1.028s1.028 1.508 1.028 2.47c0 .962-.343 1.785-1.028 2.47-.685.685-1.508 1.028-2.47 1.028zM.498 12.74v-.7c0-.495.128-.95.383-1.366a2.55 2.55 0 011.016-.951c.904-.452 1.822-.79 2.755-1.017.933-.226 1.88-.339 2.842-.339.962 0 1.91.113 2.842.34.933.225 1.85.564 2.755 1.016a2.55 2.55 0 011.016.95c.255.416.383.872.383 1.367v.7c0 .48-.171.893-.514 1.235a1.684 1.684 0 01-1.235.514H2.247c-.481 0-.893-.171-1.235-.514a1.684 1.684 0 01-.514-1.235zm1.749 0h10.494v-.7a.85.85 0 00-.437-.743 11.39 11.39 0 00-2.383-.886 10.142 10.142 0 00-4.854 0c-.801.197-1.596.492-2.383.886a.85.85 0 00-.437.743v.7zm5.247-6.996c.48 0 .893-.171 1.235-.514.343-.342.514-.754.514-1.235 0-.481-.171-.893-.514-1.235a1.684 1.684 0 00-1.235-.514c-.481 0-.893.171-1.235.514a1.684 1.684 0 00-.514 1.235c0 .48.171.893.514 1.235.342.343.754.514 1.235.514z"
        fill={color}
      />
    </svg>
  );
};
